import { useState, useEffect, useCallback } from 'react'
import Typography from '@mui/material/Typography'
import { FormSectionProps } from '../../interfaces/form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { useForm } from 'react-final-form'

import FormWizard from '../wizard'
import FormField from '../../components/FormField'

import Search from '@mui/icons-material/Search'

import * as _ from 'lodash'
import occupations from '../../data/occupations.json'

const Occupation = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const values = form.getState().values
  const [searchData, setSearchData] = useState<any[]>([])

  const getOccupationsSearch = (searchText: string) => {
    if (searchText) {
      const filteredOccupations = occupations.filter((occupation) =>
        occupation.description.toLowerCase().includes(searchText.toLowerCase())
      )
      setSearchData(filteredOccupations.slice(0, 9))
    } else {
      setSearchData([])
    }
  }

  const topLevelDebounce = useCallback(
    _.debounce(getOccupationsSearch, 1000),
    []
  )

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            What’s your partner's main occupation? Start typing and choose the
            closest match for now.
          </Typography>
          <FormField
            id="occupation"
            name="partnerOccupation"
            type="text"
            style={{ marginBottom: '80px' }}
            InputProps={{
              endAdornment: (
                <span style={{ marginLeft: 10 }}>
                  <Search color="primary" />
                </span>
              ),
            }}
            inputValue={values?.occupation?.description}
            isAutoComplete={true}
            autocompleteData={searchData}
            onInputChange={(e) => {
              topLevelDebounce(e.target.value)
            }}
          />
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default Occupation
